import React, { useEffect, useState } from 'react';
import api, { isSupervisorRole, getCurrentUser } from '../api/expoApi';

/**
 * HubSelector - dropdown of hubs for ADMIN/MANAGEMENT,
 * disabled with current hub for everyone else.
 */
export default function HubSelector({ value, onChange, includeAllOption = true, label = 'Hub' }) {
    const [hubs, setHubs] = useState([]);
    const user = getCurrentUser();
    const isSupervisor = isSupervisorRole(user?.role);

    useEffect(() => {
        api.get('/hubs-extended')
            .then((r) => setHubs(r.data?.data || []))
            .catch(() => setHubs([]));
    }, []);

    if (!isSupervisor) {
        const myHub = hubs.find((h) => h.hub_id === (user?.hub_id || user?.hubId));
        return (
            <div className="hub-selector locked">
                <label>{label}:</label>
                <span className="hub-name">
                    {myHub ? `${myHub.code} — ${myHub.name}` : 'Your hub'}
                </span>
            </div>
        );
    }

    return (
        <div className="hub-selector">
            <label>{label}:</label>
            <select value={value || ''} onChange={(e) => onChange(e.target.value || null)}>
                {includeAllOption && <option value="">All hubs</option>}
                {hubs.map((h) => (
                    <option key={h.hub_id} value={h.hub_id}>
                        {h.code} — {h.name}
                    </option>
                ))}
            </select>
        </div>
    );
}
